import { React, useEffect, useState } from 'react';

import {
  Dialog,
  TextInputField,
  FormField,
  Button,
  Pane,
  Menu,
  Popover,
  ChevronDownIcon,
  ArrowTopRightIcon,
  ArrowBottomRightIcon,
  SelectField,
  Switch,
  Heading,
} from 'evergreen-ui';
import { Container, Row, Col } from 'react-grid-system';

import { mutate } from 'swr';
import { useForm } from 'react-hook-form';

import { postCategory } from '../../../services/api/categoriesService';
import { useQueryAccountPlans } from '../../../services/api/accountPlansService';
import { toastNotification } from '../../../shared/toastNotification';

import { inputCategoryValidation } from '../../../helpers/formHelper';
import LoadingOverlay from '../../../shared/LoadingOverlay';

function CategoryFormComponent({ isShown, setIsShown }) {
  const companyId = localStorage.getItem('companyId');
  const [isDisabled, setIsDisabled] = useState(true);

  /* API calls */

  const { data: accountPlans = [], isLoading: isLoadingAccountPlans } = useQueryAccountPlans(
    // company.data.id,
    companyId,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  /* Form */

  const { formState, register, handleSubmit, reset, setValue, watch } = useForm({
    defaultValues: { enabled: true },
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    inputCategoryValidation(watch('name'), watch('isInput'), watch('accountPlanId'), setIsDisabled);
  }, [watch('isInput'), watch('name'), watch('accountPlanId')]);

  const categoryFormFooter = () => {
    return (
      <Pane>
        <Button
          form="category-form"
          type="submit"
          width="fit-content"
          id="onSubmit"
          disabled={isDisabled}
        >
          Salvar
        </Button>
      </Pane>
    );
  };

  const onSubmit = (category) => {
    console.log('onSubmit', category);
    let statusResponse = false;
    let toastContent = '';

    let categoryToCreate = {
      name: category.name,
      companyId: companyId,
      isInput: category.isInput,
      accountPlanId: category.accountPlanId,
      enabled: !!category.enabled,
    };

    postCategory(categoryToCreate)
      .then((res) => {
        console.log('res post category: ', res);
        mutate(`categories-${companyId}`);
        statusResponse = 'success';
        toastContent = 'Categoria salva com sucesso.';
        onClose();
      })
      .catch((err) => {
        statusResponse = 'warning';
        console.log('post err', err);
        toastContent = `Verifique os campos novamente.`;
      })
      .finally(() => {
        toastNotification(statusResponse, toastContent);
      });
  };

  const onClose = () => {
    console.log('onClose function');
    reset();
    setIsShown(false);
  };

  if (isLoadingAccountPlans) {
    return <LoadingOverlay />;
  }

  return (
    <Dialog
      isShown={isShown}
      title="Nova categoria"
      onCloseComplete={onClose}
      confirmLabel="Custom Label"
      hasFooter={true}
      footer={categoryFormFooter}
      shouldCloseOnEscapePress={!formState.isDirty}
      width={800}
      backgroundColor="#f8f8f8"
    >
      <div>
        <form id="category-form" onSubmit={handleSubmit(onSubmit)}>
          <FormField>
            <Container
              fluid={true}
              style={{
                width: '100%',
                margin: 'none',
                padding: 'none',
              }}
            >
              <Row>
                <Col sm={12} md={12} lg={6}>
                  <TextInputField
                    {...register('name', { required: true })}
                    label="Categoria"
                    id="name"
                    name="name"
                    type="text"
                  />
                </Col>
                <Col sm={12} md={12} lg={6}>
                  <SelectField
                    {...register('accountPlanId')}
                    label="Plano de Conta"
                    onChange={(e) => setValue('accountPlanId', e.target.value)}
                  >
                    <option value=""></option>
                    {!isLoadingAccountPlans &&
                      accountPlans.data
                        .filter((accountPlan) => {
                          return accountPlan.isInput === watch('isInput');
                        })

                        .map((item) => {
                          console.log(item);
                          return (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          );
                        })}
                  </SelectField>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Popover
                    content={
                      <Menu
                        {...register('isInput', {
                          value: undefined,
                        })}
                      >
                        <Menu.Group>
                          <Menu.Item
                            icon={ArrowTopRightIcon}
                            intent="selected"
                            onSelect={() => {
                              setValue('isInput', true);
                            }}
                          >
                            Entrada
                          </Menu.Item>
                          <Menu.Item
                            icon={ArrowBottomRightIcon}
                            intent="danger"
                            onSelect={() => {
                              setValue('isInput', false);
                            }}
                          >
                            Saída
                          </Menu.Item>
                        </Menu.Group>
                      </Menu>
                    }
                  >
                    <Button
                      marginRight={15}
                      id="categoryType"
                      type="button"
                      iconAfter={ChevronDownIcon}
                    >
                      {watch('isInput') === undefined
                        ? 'Classificação'
                        : watch('isInput')
                        ? 'Entrada'
                        : 'Saída'}
                    </Button>
                  </Popover>
                </Col>
                <Col sm={12} md={12} lg={6} style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                  <Heading size={400} marginBottom={4}>
                    Habilitado
                  </Heading>
                  <Switch
                    checked={!!watch('enabled')}
                    onChange={(e) => setValue('enabled', e.target.checked)}
                  />
                </Col>
              </Row>
            </Container>
          </FormField>
        </form>
      </div>
    </Dialog>
  );
}

export default CategoryFormComponent;
